<span [innerHTML]="_safeValue"></span><span #projectedContent style="display:none"><ng-content></ng-content></span>